import * as React from "react";
import type { SVGProps } from "react";
const SvgShare2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.093 12.646a1 1 0 1 0-1.006 1.728zm5.823 5.708a1 1 0 1 0 1.008-1.728zm.998-10.98a1 1 0 1 0-1.008-1.728zM8.086 9.626a1 1 0 1 0 1.008 1.728zM20 5a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V1a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zM8 12a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2H2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V8a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm14 9a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm-9.913-2.626 6.83 3.98 1.007-1.728-6.83-3.98zm6.819-8.728-6.82 3.98 1.008 1.728 6.82-3.98z"
    />
  </svg>
);
export default SvgShare2;
